import { api } from "@/api"
import type { User } from "./types"

export type RetrieveUserResponse = User

export const retrieveUser = async (userId: User["id"]) => {
  const { body } = await api.get<
    RecursivelyConvertDatesToStrings<RetrieveUserResponse>
  >(`/users/${userId}/`)

  return body
}
